<template>
  <div class="mt-3">
    <div
      :class="modal ? 'product-cards-modal' : 'product-cards'"
      v-if="!empty | (this.dataset.length == 0)"
    >
      <div
        :class="modal ? 'card-modal' : 'card'"
        v-for="set in dataset"
        :key="set.id"
      >
        <line-chart
          :title="set.nombre"
          class="chart"
          :data="set.data"
          xtitle="Fecha"
          :ytitle="set.unidad"
          v-if="set.data.length > 0"
        ></line-chart>
        <!-- &&
          set.nombre == 'Temperatura' &&
          set.nombre == 'Humedad' &&
          set.nombre == 'CO2' &&
          set.nombre == 'Luminosidad' -->
        <div v-else class="msg-alert">
          <h4>No hay datos recogidos por el sensor '{{ set.nombre }}''</h4>
          <v-icon size="150">mdi-leak-off</v-icon>
        </div>
      </div>
    </div>
    <div v-else class="msg-alert">
      <h4>No hay datos recogidos por los sensores</h4>
      <v-icon size="250">mdi-leak-off</v-icon>
    </div>
  </div>
</template>

<script>
import SensorService from "@/services/SensorService";
export default {
  props: {
    maquinas: {
      type: Array,
      default: () => []
    },
    modal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      params: [],
      dataset: [],
      empty: false,
      fecha1: "1890-11-11",
      fecha2: "3000-11-11",
      tab: null
    };
  },
  computed: {
    formData: function() {
      return {
        maquinas: this.maquinas,
        fecha1: this.fecha1,
        fecha2: this.fecha2
      };
    }
  },
  async mounted() {
    await this.getParams();
    try {
      await this.setData();
      await this.isEmpty();
    } catch (e) {
      this.empty = true;
    }
  },
  methods: {
    async getParams() {
      var obj = await SensorService.getAllParams();
      this.params = obj.data;
    },
    async setData() {
      var data = [];
      for (let i = 0; i < this.params.length; i++) {
        var aux = this.formData;
        aux.id_parametro = this.params[i].id;
        try {
          var obj = await SensorService.getDash(aux);
          data.push({
            id_parametro: this.params[i].id,
            data: obj.data,
            nombre: this.params[i].nombre,
            unidad: this.params[i].unidad
          });
        } catch (e) {}
      }

      data[3].nombre = "CO2";
      data[3].unidad = "ppp";
      data[5].nombre = "Luminosidad";
      data[5].unidad = "cd";
      // var copy = [...data]
      for (let i = 1; i <= 5; i++) {
        if (i != 4) {
          this.dataset.push(data[i]);
        }
      }
     
      //this.dataset = data;
    },
    async isEmpty() {
      var sensoresSinDatos = 1;
      this.dataset.forEach(d => {
        if (d.data.length > 0) {
          sensoresSinDatos++;
        }
      });
      if (sensoresSinDatos == this.dataset.length) this.empty = true;
      else return;
    }
  }
};
</script>

<style scoped>
.product-cards {
  display: flex;
  padding: 1rem 0;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.product-cards-modal {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: column;
}
.card {
  box-shadow: 0 0 5px #00000040;
  transition: 0.4s;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 48%;
  height: fit-content;
}
.card-modal {
  box-shadow: 0 0 5px #00000040;
  transition: 0.4s;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 70%;
  height: fit-content;
}
.card:hover {
  box-shadow: 0 0 10px #00000040;
  transform: scale(1.02);
}
.chart {
  padding: 2em;
  height: 55vh !important;
}
.chartContainer {
  width: 100%;
}
.msg-alert {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 2.2em;
}
.card .msg-alert,
.card-modal .msg-alert {
  height: 55vh !important;
  padding: 0;
}
@media screen and (max-width: 1000px) {
  .product-cards,
  .product-cards-modal {
    flex-direction: column;
  }
  .card,
  .card-modal {
    width: 80%;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/DataSensorChart.vue